module.exports = __webpack_public_path__ + "assets/img/00159.e48338dc.png";